// Helpers per orari settimanali dinamici
export const DAYS = [
  { key: "mon", label: "Lunedì" }, { key: "tue", label: "Martedì" },
  { key: "wed", label: "Mercoledì" }, { key: "thu", label: "Giovedì" },
  { key: "fri", label: "Venerdì" }, { key: "sat", label: "Sabato" },
  { key: "sun", label: "Domenica" },
];

export const defaultDay = () => ({ mode: "closed", am_open: "", am_close: "", pm_open: "", pm_close: "" });

export const defaultHours = () => DAYS.reduce((acc, d) => ({ ...acc, [d.key]: defaultDay() }), {});

const todayKey = () => DAYS[(new Date().getDay() + 6) % 7].key;

const toMin = (hhmm) => {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
};

export const openStatus = (hours) => {
  if (!hours) return { open: false, label: "Orari non disponibili", today: null };
  const day = hours[todayKey()];
  if (!day || day.mode === "closed") return { open: false, label: "Chiuso oggi", today: day };
  if (day.mode === "24h") return { open: true, label: "Aperto 24 ore", today: day };
  if (day.mode === "appointment") return { open: false, label: "Solo su appuntamento", today: day };
  const now = new Date();
  const cur = now.getHours() * 60 + now.getMinutes();
  const ranges = [];
  if (day.mode === "continuous") {
    ranges.push([toMin(day.am_open), toMin(day.pm_close || day.am_close)]);
  } else {
    if (day.am_open && day.am_close) ranges.push([toMin(day.am_open), toMin(day.am_close)]);
    if (day.pm_open && day.pm_close) ranges.push([toMin(day.pm_open), toMin(day.pm_close)]);
  }
  const inside = ranges.find(([a, b]) => a !== null && b !== null && cur >= a && cur < b);
  if (inside) return { open: true, label: `Aperto ora · chiude alle ${String(Math.floor(inside[1]/60)).padStart(2,"0")}:${String(inside[1]%60).padStart(2,"0")}`, today: day };
  return { open: false, label: "Chiuso ora", today: day };
};

export const formatDay = (d) => {
  if (!d || d.mode === "closed") return "Chiuso";
  if (d.mode === "24h") return "Aperto 24 ore";
  if (d.mode === "appointment") return "Su appuntamento";
  const parts = [];
  if (d.mode === "continuous") {
    if (d.am_open && (d.pm_close || d.am_close)) parts.push(`${d.am_open}–${d.pm_close || d.am_close}`);
  } else {
    if (d.am_open && d.am_close) parts.push(`${d.am_open}–${d.am_close}`);
    if (d.pm_open && d.pm_close) parts.push(`${d.pm_open}–${d.pm_close}`);
  }
  return parts.length ? parts.join(" · ") : "Chiuso";
};

export const SERVICES_PRESETS = [
  "Consegna a domicilio", "Prenotazione", "Acquisto online", "Ritiro in sede",
  "Parcheggio", "Accessibilità disabili", "Animali ammessi", "Wi-Fi",
  "Aria condizionata", "Bagno clienti", "Pagamenti con carta", "Contactless",
  "Buoni regalo", "Assistenza", "Servizio a domicilio", "Appuntamento online",
  "Area bambini", "Tavoli esterni", "Take away", "Spedizione",
];
